import { useState, useRef, useEffect } from 'react';
import { useSearchBox } from 'react-instantsearch';

import { Container, useTranslation } from '@weareconceptstudio/core';

//* Custom SVG Icon
import { searchSVG } from './utils';

const closeSVG = (
	<svg
		width='18'
		height='18'
		fill='none'
		viewBox='0 0 16 17'
		className='close-svg cursor-pointer'>
		<path
			d='M3.75781 12.9863L12.2431 4.50105'
			stroke='var(--white1000)'
			strokeWidth='1.33333'
		/>
		<path
			d='M3.75781 4.5L12.2431 12.9853'
			stroke='var(--white1000)'
			strokeWidth='1.33333'
		/>
	</svg>
);

const SearchBox = ({ initialQuery = '', onClear, ...props }) => {
	const { query, refine } = useSearchBox(props);
	const { translate } = useTranslation();

	//! States
	const [inputValue, setInputValue] = useState(initialQuery);
	const [isChanged, setIsChanged] = useState(false);

	//! Ref
	const inputRef = useRef(null);

	useEffect(() => {
		if (initialQuery !== query) {
			setInputValue(initialQuery);
			refine(initialQuery);
		}
	}, [initialQuery]);

	useEffect(() => {
		setInputValue(query);
	}, [query]);

	const handleSearch = () => {
		refine(inputValue);
		setIsChanged(false);
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			handleSearch();
		}
	};

	const handleClear = () => {
		refine('');
		setInputValue('');
		onClear?.();
		inputRef.current?.focus();
	};

	return (
		<Container
			row
			full>
			<div className={`col-5 col-m-12 search-field-container new-version ${inputValue && !isChanged ? 'disable-search-button' : ''}`}>
				<div className='search-input-wrapper'>
					<input
						ref={inputRef}
						type='text'
						autoCorrect='off'
						autoComplete='off'
						autoCapitalize='off'
						className='search-field'
						placeholder={translate('typeToSearch')}
						value={inputValue}
						onKeyDown={handleKeyDown}
						onChange={(e) => {
							setInputValue(e.currentTarget.value);
							!isChanged && setIsChanged(true);
						}}
					/>
					<button
						type='button'
						className='search-button'
						onClick={query ? handleClear : handleSearch}
						disabled={!query.trim() && !isChanged}>
						{query ? closeSVG : searchSVG}
					</button>
				</div>
			</div>
		</Container>
	);
};

export default SearchBox;
